import { Bell, X } from 'lucide-react';
import { getNotificationService, useNotifications } from '../notifications/service.ts';
import { useUi } from '../App.tsx';
import { tr } from '../i18n/i18n.ts';

/** Endast lokal webbprofil utan bakgrundskanal: påminnelser medan appen är öppen. Tydligt märkt. */
export function InAppReminders() {
  const { inApp } = useNotifications();
  const ui = useUi();
  if (!inApp.length) return null;
  return (
    <div className="fixed inset-x-0 top-2 z-50 flex flex-col items-center gap-2 px-3" aria-live="assertive">
      {inApp.slice(-3).map((n) => (
        <div key={n.id} role="alert" className="flex w-full max-w-md items-start gap-3 rounded-xl border border-accent/60 bg-raised px-4 py-3 shadow-xl">
          <Bell size={18} className="mt-0.5 text-accent" aria-hidden />
          <div className="min-w-0 flex-1">
            <p className="font-semibold">{n.title}</p>
            <p className="text-sm text-muted">{n.body}</p>
            <p className="mt-1 text-xs text-muted">{tr('Visas eftersom AutoDay är öppen – denna profil har inga bakgrundsnotiser.', 'Shown because AutoDay is open – this profile has no background notifications.')}</p>
            <button
              className="mt-1 min-h-11 text-sm font-medium text-accent hover:underline"
              onClick={() => {
                ui.openItem({ ref: n.open.kind === 'local' ? n.open.id : n.open.key, occurrenceKey: n.open.occurrenceKey });
                getNotificationService().dismissInApp(n.id);
              }}
            >
              {tr('Öppna', 'Open')}
            </button>
          </div>
          <button aria-label={tr('Stäng påminnelse', 'Close reminder')} className="grid min-h-11 min-w-11 place-items-center rounded-lg text-muted hover:text-text" onClick={() => getNotificationService().dismissInApp(n.id)}>
            <X size={18} aria-hidden />
          </button>
        </div>
      ))}
    </div>
  );
}
